import React from "react";
import { formatSmartRtpNumber } from "../../../../utils/bigMath";

function formatValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "number") {
    return formatSmartRtpNumber(value, 3);
  }
  return value;
}

export default function SmartRtpCards({ cards = [] }) {
  return (
    <div className="row">
      {cards.map((card) => (
        <div className="col-md-3 mb-3" key={card.key}>
          <div className="card shadow h-100">
            <div className="card-body">
              <div className="text-muted small mb-2">{card.label}</div>
              <div style={{ fontSize: "1.6rem", fontWeight: 700 }}>
                {formatValue(card.value)}
              </div>
              {card.helper ? (
                <div className="text-secondary small mt-2">{card.helper}</div>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
